// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"MessageWrapperWithFadeOut_messageContainer__MUbod","fade-out":"MessageWrapperWithFadeOut_fade-out__F_w0t"};